<template>
  <center>

 <div class="container">
      <Header pageTitle="Manage Partner Nation" class="card-container"></Header>
      <el-divider class="divider-green"></el-divider>
      <el-table :data="filterTableData" style="width: 100%">
        <el-table-column label="Country Name" >
          <div slot-scope="props">
            {{props.row.name.toUpperCase() }}

          </div>
        </el-table-column>
        <el-table-column align="right">
      <template #header>
        <el-input v-model="search" size="small" placeholder="Type to search" />
      </template>
      <template #default="scope">
        <el-switch
        @change="updateCountry(scope.$index,scope.row)"
    v-model="scope.row.isPartnerNationApproval"
    class="ml-2"
    style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
  />
      </template>
    </el-table-column>
      </el-table>
    </div>
</center>

</template>

<script>
import axios from "@/axios";
import Header from "@/components/App/Header";
import { mapGetters, mapActions } from "vuex";

import {
  Table,
  Switch,
  TableColumn,
  Upload,
  Button,
  Tag,
  Select,
  Option,
  Alert,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Divider,
  Tooltip,
  Card,
} from "element-ui";
export default {
  name: "PartnerNation",
  components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [Switch.name]: Switch,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Tooltip.name]: Tooltip,
    [FormItem.name]: FormItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    Header,
  },
  mounted(){
    this.getAllCountries()
  },
  data(){
    return{
      search: '',
    }
  },
  computed:{
    filterTableData(){
      let data  = this.allCountries.filter(
    (data) =>
      !this.search ||
      data.name.toLowerCase().includes(this.search.toLowerCase())
      
  )
  return data.sort((a,b) => a.name - b.name);
    },
    ...mapGetters({
    allCountries: "countries/allCountries",})
  },
  methods:{
    ...mapActions({
    getAllCountries: "countries/getAllCountries",}),
    async updateCountry(id,country){
      try{
        const response = await axios.post("/api/countries" , country)
        return
      }catch(err){
        this.$toast.error(`client response: ${err}`);
          return false;
      }
    }
  }
  }
</script>